import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Box, Stack, Typography} from 'views/components';

import {Translate} from 'views/module';

const SubscribeUserDialog = ({open, onClose, onSubmit, initialEmail, isLoading}) => {
  const [email, setEmail] = React.useState(initialEmail);

  React.useEffect(() => {
    setEmail(initialEmail);
  }, [initialEmail, open]);

  const handleChange = (newValue) => {
    setEmail(newValue);
  };

  const isFormValid = React.useCallback(() => {
    return email?.trim();
  }, [email]);

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle onClose={onClose}>
        <Translate expression='client.ClientDetail.Relationships.Notification.Subscribe' />
      </DialogTitle>
      <DialogContent>
        <Box>
          <Stack spacing={2}>
            <Box>
              <Typography variant="h6"></Typography>
            </Box>
            <TextField
              label={<Translate expression='client.ClientDetail.Relationships.Details.ContactTypeExample.Email' />}
              value={email}
              onChange={(e) => handleChange(e)}
              fullWidth
            />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="primary" variant="contained" onClick={() => onSubmit(email)} disabled={isLoading || !isFormValid()}>
          <Translate expression='client.ClientDetail.Relationships.Notification.Subscribe' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SubscribeUserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialEmail: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

export default SubscribeUserDialog;
